export default {
    
    "2023":[
        {
            "title": "Shaukat Sohail",
            "desc":"MERN Stack Developer",
            "image":"coreteam2023/member1.jpeg"
        },
        {
            "title": "Hadi Haider",
            "desc":"Full and JAM Stack Developer",
            "image":"coreteam2023/member2.jpeg"
        },
        {
            "title": "Abdul Samad",
            "desc":"Full Stack Developer",
            "image":"coreteam2023/member3.jpeg"
        },
        {
            "title": "Rimmel Asghar",
            "desc": "AI, ML, and Python Developer",
            "image": "coreteam2023/member6.jpeg"
        },
        {
            "title": "Muhammad Rayyan",
            "desc":"AI, ML and Data analyst",
            "image":"coreteam2023/member4.jpg"
        },
        {
            "title": "Muhammad Shaheer",
            "desc": "Flutter Developer",
            "image": "coreteam2023/member5.jpeg"
        },
        {
            "title": "Syed Moosa Raza",
            "desc": "Game Developer",
            "image": "coreteam2023/member7.jpeg"
        },
        {
            "title": "Muhammad Waleed",
            "desc": "MERN Stack Developer",
            "image": "coreteam2023/member8.jpeg"
        },
        {
            "title": "Nabia Hassan Sabzwari",
            "desc": "Blockchain Developer",
            "image": "coreteam2023/member9.png"
        },
        {
            "title": "Syeda Zainab Raza",
            "desc": "Content Lead",
            "image": "coreteam2023/member10.png"
        },
       



    ],


    "2022":[
        {
            "title": "Syed Measum hassan",
            "desc":"Event Manager",
            "image":"coreteam2022/member1.jpeg"
        },

        {
            "title": "Syed Hamza Hoda",
            "desc":"Web Developer",
            "image":"coreteam2022/member2.jpg"
        },
        {
            "title": "Abdul Wassay",
            "desc":"Software Developer",
            "image":"coreteam2022/member3.jpg"
        },
        {
            "title": "Muhammad Ismail Mian",
            "desc":"Software Developer",
            "image":"coreteam2022/member5.jpg"
        },
        {
            "title": "Zain Shahzad Paracha",
            "desc":"Event Manager",
            "image":"coreteam2022/member4.jpeg"
        },
        {
            "title": "Muhammad Waqar",
            "desc":"Graphic Designer",
            "image":"coreteam2022/member6.png"
        },
        {
            "title": "Fahad Farooq",
            "desc":"Graphic Designer",
            "image":"coreteam2022/member7.jpeg"
        },

    ],

    "2021":[
      
    ]



}